module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
    
    fox.registerWidget('ThroughChatWindow', {

        configure: function () {
            this.registerOptions('', {
                autoRender: true,
                template: 'throughtChatWindow',
                defaultHeight: 440,
                staticWidth: 335,
                embed: {
                    container: '.wrapper',
                    location: 'lastChild'
                },

                templateOptions: {
                    chatWindowHidden: true,//fox.utils.localStorage('getItem', 'chatWindowHidden')
                },

                widgets: {
                    conversationViewer: {
                        widget: 'ConversationViewer',
                        markAsReadOnAir: false,
                        markAsReadOnWindowFocus: false,
                        template: 'throughtChatWindow_messages_container',
                        'scrollbar.position': 'inside',
                        'scrollbar.theme': 'minimal',
                        'embed.container': '.chat-wrapper',
                        'list.embed.container': '.messages-list',
                        'list.tpl.row': 'throughtChatWindow_messages_item',
                        'handleDom.sendByEnter.callback': function (el, alias, scope, e) {
                            if (e.ctrlKey === true && e.keyCode === 13) {
                                setTimeout(fox.bind(function () {
                                    this.sendMessageHandler();
                                }, this), 10);
                            }

                            if ([13, 46, 8].indexOf(e.keyCode) !== -1) {
                                setTimeout(function () {
                                    el.style.height = [20 * el.value.split('\n').length, 'px'].join('');
                                }, 10);
                            }
                        }
                    }
                },

                handleWom: {
                    messageReceived: {
                        widget: '@root #newMessageCount',
                        event: 'cameNewMessages',
                        callback: '_handleIncomingMessage'	
                    }
                },

                handleDom: {
                    hide: {
                        target: '.close',
                        event: 'click',
                        callback: 'hideWindow'
                    },

                    show: {
                        target: '.througth-chat-notifications',
                        event: 'click',
                        callback: 'showWindow'
                    },
                }
            });

            this.callParent('configure', arguments);
        },

        beforeEmbed: function () {
            if (fox.utils.isTouchDevice() || !this._wom.getRoot().member) {
                return false;
            }

            return this.callParent('beforeEmbed', arguments);
        },

        running: function (argument) {
            if (this._disabled) return false;

            this.convViewer = this.wom1('#conversationViewer');

            $(window).on('resize', {w: this}, this._handleWindowResize);

            this.handleEvent(fox.Navigator, 'modified_0', this._handleNaviChange);

            this.callParent('running', arguments);
        },

        addedToDom: function () {
            window.setTimeout(fox.bind(function () {
                this.applyHeight(this.getHeight());
                this.makeDraggable();
            }, this), 500);
        },

        makeDraggable: function (argument) {
            this.getChatContainer().draggable({
                handle: '.chat-title',
                containment: 'window',
                stop: fox.bind(function(ev, ui) {
                    this.savePosition(ui.offset);
                }, this)
            }).resizable({
                maxWidth: this.getOption('staticWidth'),
                minWidth: this.getOption('staticWidth'),
                minHeight: this.getOption('defaultHeight'),
                containment: 'document',
                handles: {
                    n: '.resize.resize-n',
                    s: '.resize.resize-s'
                },
                resize: fox.bind(function (ev, ui) {
                    this.updateScrollBar();
                }, this),
                stop: fox.bind(this._handleResizeStop, this)
            });

            var position = this.getPosition();

            if (position) {
                this.applyOffset(position);
            }

            this.makeVisible();
        },

        makeVisible: function (argument) {
            this.getChatContainer().css('visibility', 'visible');
        },

        getHeight: function () {
            var h = fox.utils.localStorage('getItem', 'chatWindowHeight');

            if (!h) {
                return false;
            }

            return h;
        },

        applyHeight: function (h) {
            h = (h > window.innerHeight ? h = window.innerHeight : h);
            this.getChatContainer().height((h || this.getOption('defaultHeight')) + 'px');
        },

        saveHeight: function (h) {
            fox.utils.localStorage('setItem', 'chatWindowHeight', h);
        },

        savePosition: function (offset) {
            fox.utils.localStorage('setItem', 'chatWindowPosition', [(offset.top - window.scrollY) , offset.left].join(':'));
        },

        getPosition: function (argument) {
            var offset = fox.utils.localStorage('getItem', 'chatWindowPosition');

            if (!offset) {
                return false;
            }

            offset = offset.split(':');
            
            return {top: offset[0], left: offset[1]};
        },

        getChatContainer: function (argument) {
            return this.element && $(this.element[0]).find('.througth-chat-wrapper');
        },

        applyOffset: function (offset) {
            fox.each(offset, function (val, prop) {
                this.getChatContainer().css(prop, val + 'px');
            }, this);
        },

        updateScrollBar: function (argument) {
            $(this.convViewer.element[0])
                .find('#messages-list-scroll-wrapper')
                .mCustomScrollbar("update");
        },

        _handleResizeStop: function (ev, ui) {
            this.saveHeight(ui.size.height);
            this.updateScrollBar();
        },

        hideWindow: function (argument) {
            this.getChatContainer().addClass('hidden');
            fox.utils.localStorage('setItem', 'chatWindowHidden', 1);
        },

        showWindow: function (argument) {
            this.getChatContainer().removeClass('hidden');
            fox.utils.localStorage('removeItem', 'chatWindowHidden');
            this.convViewer.delayedAsReadMarking(1000);
        },

        _handleIncomingMessage: function (data) {
            this.insertNumber(data.total);
        },

        insertNumber: function (num) {
            var elm = this.dom1('.counter .num');
            var cont = this.dom1('.througth-chat-notifications');
            var newIncoming = fox.dom.hasClass('exists', cont);

            this.count = num;

            if (num === 0) {
                elm.innerHTML = '';
                fox.dom.removeClass('exists', cont);
                fox.dom.removeClass('new', cont);
                return;
            }

            var txt = (num > 1 ? 'new messages' : 'new message');

            elm.innerHTML = [num, txt].join(' ');
            fox.dom.addClass('exists', cont);
            fox.dom.addClass('new', cont);

            if (newIncoming) {
                fox.dom.removeClass('new', cont);
                this.window.setTimeout(fox.bind(function (argument) {
                    fox.dom.addClass('new', cont);
                }, this), 100);
            }
        },

        _handleWindowResize: function (e) {
            var w = e.data.w;

            if (w.timer) {
                w.window.clearTimeout(w.timer);
            }

            w.timer = w.window.setTimeout(fox.bind(function (argument) {
                this.checkDimmensionsOnResize();
            }, w), 1000);
        },

        checkDimmensionsOnResize: function (argument) {
            var elm  = this.getChatContainer();
            var top = this.getPosition().top;
            var left = this.getPosition().left;
            var height = this.getHeight();
            var wWidth = $(window).width();
            
            if (!elm)
                return false;

            if ((elm.width() + elm.offset().left) > wWidth) {
                left = wWidth - elm.width();
            }

            if ((elm.height() + elm.offset().top) > window.innerHeight) {
                top = window.innerHeight - elm.height();
            }

            if (elm.height() > window.innerHeight) {
                height = this.getOption('defaultHeight');
                top = window.innerHeight - elm.height();
            }

            if (top < 0) {
                top = 0;
            }

            if (left < 0) {
                left = 0;
            }

            this.savePosition({top: top, left: left});
            this.saveHeight(height);

            this.getChatContainer().css({
                left: left + 'px',
                top: top + 'px',
                height: height + 'px'
            });

            this.updateScrollBar();
            
        },

        _handleNaviChange: function (page) {
            if (page == 'conversation') {
                this.toggle('hide');

                return;
            }

            this.toggle('show');
        },

        toggle: function (state) {
            if (this._indom && this.element[0]) {
                this.element[0].style.display = (state == 'hide' ? 'none' : '');

                return;
            }

            this.waitEvent(this, 'addedToDom', fox.bind(function (argument) {
                this.toggle(state);
            }, this));
        },

        isVisible: function () {
            if (this.isEmbedded()) {
                return $(this.element).is(':visible');
            }

            return false;
        }

    }, 'Widget');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/throughChatWindow.js
// module id = 918
// module chunks = 4